import { Check, X } from 'lucide-react';

/**
 * True/false answer: two big tappable buttons. Controlled, knows nothing
 * about correctness (grading is server-side). The value is the chosen
 * boolean, undefined until the learner picks.
 */
export function TrueFalseAnswer({
  value,
  onChange,
  disabled,
  ariaLabelledBy,
}: {
  value: boolean | undefined;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  ariaLabelledBy?: string;
}) {
  const choices: { label: string; val: boolean; icon: typeof Check }[] = [
    { label: 'True', val: true, icon: Check },
    { label: 'False', val: false, icon: X },
  ];
  return (
    <div role="radiogroup" aria-labelledby={ariaLabelledBy} className="grid grid-cols-2 gap-2">
      {choices.map(({ label, val, icon: Icon }) => {
        const selected = value === val;
        return (
          <button
            key={label}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(val)}
            className={`flex min-h-[56px] items-center justify-center gap-2 rounded-token-sm border px-4 py-3 text-sm font-medium transition-colors disabled:opacity-60 ${
              selected
                ? 'border-accent bg-accent/10 text-fg'
                : 'border-line/10 bg-surface text-fg hover:bg-surface-2'
            }`}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
